import { fieldOptional } from "./helpers"

export const boolOptional = fieldOptional

export const boolTrue = v => (v ? "" : "You must agree")
